import { render, staticRenderFns } from "./UserInvitationModal.vue?vue&type=template&id=ff686d00&"
import script from "./UserInvitationModal.vue?vue&type=script&lang=js&"
export * from "./UserInvitationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports